import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const query = graphql`
  query {
    placeholderImage: file(
      relativePath: { eq: "main-characteristics/planned.jpg" }
    ) {
      relativePath
      name
      childImageSharp {
        fixed(width: 400, height: 400) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const Singers = props => {
  const data = useStaticQuery(query)

  return (
    <Img
      fixed={data.placeholderImage.childImageSharp.fixed}
      {...props}
      imgStyle={{
        display: 'inline-block',
      }}
      style={{
        // display: 'flex',
        margin: '3px',
        filter: 'drop-shadow(0px 0px 3px rgba(0,0,0,0.3))',
      }}
    />
  )
}

export default Singers
